"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewSystemsMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.createNewSystemsMutation = (0, graphql_tag_1.default) `
  mutation CreateNewSystems($input: [CreateSystemInputType!]!) {
    createSystem(systemSettings: $input)
  }
`;
//# sourceMappingURL=create-new-systems.js.map